import { render, staticRenderFns } from "./AppAvatar.vue?vue&type=template&id=0cb9f480&scoped=true"
import script from "./AppAvatar.vue?vue&type=script&lang=js"
export * from "./AppAvatar.vue?vue&type=script&lang=js"
import style0 from "./AppAvatar.vue?vue&type=style&index=0&id=0cb9f480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb9f480",
  null
  
)

export default component.exports